import { useState } from 'react';
import {
  Box,
  Typography,
  FormControl,
  TextField,
  alpha,
  Divider,
  Button,
} from '@mui/material';

const ColorPickerSettings = ({ app, deployment, onSave }) => {
  const [selectedColor, setSelectedColor] = useState(
    deployment?.config?.themeColor || '#000000',
  );
  const [error, setError] = useState(false);

  const handleColorChange = (event) => {
    const color = event.target.value;
    setSelectedColor(color);
    setError(!/^#[0-9A-F]{6}$/i.test(color));
  };

  const handleSave = () => {
    onSave({ themeColor: selectedColor });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
        <Typography variant="h6">Farbauswahl für das Pass-Tool</Typography>
        <Divider />
      </Box>
      <Typography variant="body1" sx={{ mb: 3, mt: 3 }}>
        Wählen Sie eine Farbe für {app?.title || deployment?.title}.
      </Typography>

      <FormControl fullWidth>
        <Box
          sx={{ display: 'flex', gap: 2, alignItems: 'center', width: '90%' }}
        >
          <TextField
            sx={{ flex: 1 }}
            label="Farbe (Hex)"
            value={selectedColor}
            onChange={handleColorChange}
            error={error}
            helperText={
              error
                ? 'Bitte geben Sie einen gültigen Hex-Farbwert ein (z.B. #FF0000)'
                : ''
            }
            placeholder="#000000"
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <input
              type="color"
              value={selectedColor}
              onChange={(e) => setSelectedColor(e.target.value)}
              style={{
                width: '40px',
                height: '40px',
                padding: 0,
                border: 'none',
                cursor: 'pointer',
              }}
            />
            <Typography variant="caption" color="text.secondary">
              Farbwähler
            </Typography>
          </Box>
        </Box>
      </FormControl>

      {selectedColor && !error && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Ausgewählte Farbe:
          </Typography>
          <Box
            sx={{
              p: 2,
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.background.default, 0.7),
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: 0.5,
                bgcolor: selectedColor,
                border: '1px solid',
                borderColor: 'divider',
              }}
            />
            <Typography>{selectedColor.toUpperCase()}</Typography>
          </Box>
        </Box>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }} // This pushes the button to the bottom right
      >
        Speichern
      </Button>
    </Box>
  );
};

export default ColorPickerSettings;
